import React, { Component } from 'react';
import classNames from 'classnames';

export interface ContractAccuracyBadgeHandler {
  // contractAccuracy: 'A'|'B'|'C'|'D'|'E'|'未入力'|'その他'|null
  contractAccuracy: string;
}

export default class ContractAccuracyBadge extends Component<ContractAccuracyBadgeHandler, any> {
  render() {
    const { contractAccuracy } = this.props;

    return (
      <div
        className={classNames('uc-tag accuracy-tag', {
          'is-blue': contractAccuracy == 'A',
          'is-green': contractAccuracy == 'B',
          'is-yellow': contractAccuracy == 'C',
          'is-red': contractAccuracy == 'D',
        })}
        data-testid='contractAccuracy'
        data-testid-e2e='contractAccuracy'>
        {contractAccuracy ? contractAccuracy : '-'}
      </div>
    );
  }
}
